<template>
  <div>
    <q-select
      dense
      outlined
      :model-value="props.modelValue"
      @update:model-value="(value) => $emit('update:modelValue', value)"
      :options="listaEmpresas"
      option-label="business_name"
      option-value="id"
      label="Selecione a Empresa"
      label-color="grey-6"
      behavior="menu"
      map-options
      use-input
      @filter="filtrar"
      :display-value="
        modelValue?.business_name?.length > 9
          ? `${modelValue?.business_name?.substring(0, 9)}....`
          : modelValue?.business_name
      "
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section>Nenhum resultado</q-item-section>
        </q-item>
      </template>
      <q-tooltip v-if="modelValue">
        {{ props?.modelValue?.business_name }}
      </q-tooltip>
    </q-select>
  </div>
</template>

<script setup>
// @TODO Alterar para usar o "defineModel" das ultimas versões do vue
import { /*defineModel*/ ref, defineProps, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();
const props = defineProps({
  modelValue: {},
});

const listaEmpresas = ref([]);

const listarEmpresas = async (val) => {
  listaEmpresas.value = [];
  try {
    const response = await store.dispatch("compras/providerEmpresas", {
      vendor_id: store.state.org.unidadeData.id,
      page: 1,
      per_page: 20,
      provider: val,
      search: val,
    });
    listaEmpresas.value = response.data.results.data;
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  listarEmpresas();
});

const filtrar = async (val, update) => {
  await listarEmpresas(val);
  update();
};
</script>
